import React from "react";
import { CircularProgress } from "@mui/material";
import StyledContainer from "./LoadingOverlay.styles";

type LoadingOverlayProps = {
  loading: boolean;
};

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loading }) => {
  if (!loading) return null;

  return (
    <StyledContainer
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </StyledContainer>
  );
};

export default LoadingOverlay;
